<template>
  <v-card>
    <v-card-title>Location Information</v-card-title>
    <v-card-text v-if="assignment_data.perf_facility_map">
      {{ assignment_data.perf_facility_map.street_address }}<br>
      {{ assignment_data.perf_facility_map.city + ', ' + assignment_data.perf_facility_map.state + ' ' + assignment_data.perf_facility_map.zip}}<br>
      <a :href="assignment_data.perf_facility_map.performance_map_url" target="_blank">View in Google Maps</a><br>
      <v-checkbox
        v-model="infoVerified"
        label="Address and Maps link are both correct"
        @change="check($event)"
        :disabled=loading
        v-if="!$store.state.recordingEng"
      ></v-checkbox>
    </v-card-text>
    <v-card-text v-else class="font-italic">
      This has not yet been set by the DC staff.
    </v-card-text>
  </v-card>
</template>

<script>
import firebase from 'firebase/app'
import 'firebase/functions'

export default {
  props: {
    assignment_data: Object
  },
  data() {
    return {
      infoVerified: false,
      loading: false
    }
  },
  methods: {
    check(bool) {
      const vm = this
      const id = vm.$store.state.assignment
      const putOpusApi = firebase.functions().httpsCallable('putOpusApi')

      vm.loading = true
      putOpusApi({
        table: `vendor_assignments`,
        params: {
          id: id,
          B_Location_Reviewed: bool
        }
      }).then(function() {
        vm.loading = false
        vm.$emit('loaddata')
      })
    }
  },
  mounted() {
    // console.log(this.assignment_data)
    this.infoVerified = this.assignment_data.b_location_reviewed
  }
}
</script>